import {defineStore} from 'pinia'

/**
 * this is where the users will be stores, to be accessible to the entire application
 */
export const useUserStore = defineStore('user', {
    state: () => ({
        email: undefined as string | undefined,
        setPasswordToken: undefined as string | undefined,
    }),

    getters: {},

    actions: {},
})